
( function ( $ ) {

	$( function () {
		// Display the Filename Template setting for Post Image and File Upload fields.
		for ( fieldType in fieldSettings ) {
			if ( fieldSettings.hasOwnProperty( fieldType ) && ( fieldType === 'post_image' || fieldType === 'fileupload' ) ) {
				fieldSettings[ fieldType ] += ', .gpfr-field-setting';
			}
		}

		var $filenameTemplate = $( '#gpfr_filename_template' );

		// Listen for input in the Filename Template setting and save it to the current field.
		$filenameTemplate.on( 'input', function() {
			var field = GetSelectedField();
			if ( field ) {
				field.gpfrTemplate = $( this ).val();
			}
		} );

		// Populate the Filename Template setting from the current field.
		$( document ).bind( 'gform_load_field_settings', function ( event, field, form ) {
			$filenameTemplate.val( field.gpfrTemplate );
		} );

		// Add our custom merge tags to the Filename Template merge tag selector.
		gform.addFilter( 'gform_merge_tags', gpfrAddMergeTags );

	} );

	function gpfrAddMergeTags( mergeTags, elementId, hideAllFields, excludeFieldTypes, isPrepop, option ) {

		if ( elementId.indexOf( 'gpfr_filename_template' ) !== 0 ) {
			return mergeTags;
		}

		mergeTags.ungrouped.tags.push( {
			label: GPFileRenamer.translation.filename,
			tag: '{filename}'
		} );

		mergeTags.ungrouped.tags.push( {
			label: GPFileRenamer.translation.deduplicator,
			tag: '{dedup}'
		} );

		mergeTags.ungrouped.tags.push( {
			label: GPFileRenamer.translation.incrementer,
			tag: '{i}'
		} );

		return mergeTags;
	}

} )( jQuery );
